import $ from 'jquery';
import Cookies from 'js-cookie';
window.$ = window.jQuery = $;

$('.cookie-accept').click(function () { //on click event
	
	Cookies.set('comply_cookie', 'comply_yes', { expires: 182 });
	$("#cookies").slideUp("slow"); //jquery to slide it up
	
});